import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private tipoObra$ = new BehaviorSubject<'proceso' | 'planeación'>(null);
  private direccion$ = new BehaviorSubject<string>(null);
  private funcionalidad$ = new BehaviorSubject<string>(null);

  constructor() { }
  
  public inicializar() {
    this.actualizarBreadcrumbTipoObra(null);
    this.actualizarBreadcrumbDireccion(null);
    this.actualizarBreadcrumbFuncionalidad(null);
  }

  public actualizarBreadcrumbTipoObra(tipoObra: 'proceso' | 'planeación') { this.tipoObra$.next(tipoObra); }
  public obtenerBreadcrumbTipoObra(): Observable<'proceso' | 'planeación'> { return this.tipoObra$.asObservable(); }

  public actualizarBreadcrumbDireccion(direccion: string) { this.direccion$.next(direccion); }
  public obtenerBreadcrumbDireccion(): Observable<string> { return this.direccion$.asObservable(); }

  public actualizarBreadcrumbFuncionalidad(funcionalidad: string) { this.funcionalidad$.next(funcionalidad); }
  public obtenerBreadcrumbFuncionalidad(): Observable<string> { return this.funcionalidad$.asObservable(); }
}
